import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Paper, Typography } from "@mui/material";
import CustomAxios from "../utils/CustomAxios";
import { CustomerRallyData, RallyData } from "../type";

export const Rally = () => {
  const navigate = useNavigate();

  const [isCustomerRallyLoading, setIsCustomerRallyLoading] = useState(false);
  const [isRallyLoading, setIsRallyLoading] = useState(false);
  const [customerRallyDataDict, setCustomerRallyDataDict] =
    useState<CustomerRallyData>({});
  const [rallyDataList, setRallyDataList] = useState<RallyData[]>([]);

  useEffect(() => {
    setIsCustomerRallyLoading(true);
    setIsRallyLoading(true);
    CustomAxios.get("/customer/rally").then((res) => {
      setCustomerRallyDataDict(res.data);
      setIsCustomerRallyLoading(false);
    });

    CustomAxios.get("/rallies").then((res) => {
      setRallyDataList(res.data.rallies);
      setIsRallyLoading(false);
    });
  }, []);

  return (
    <>
      <Typography variant="h5" sx={{ my: 1 }}>
        スタンプラリー
      </Typography>

      <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
        参加中のスタンプラリー
      </Typography>
      {isCustomerRallyLoading ? (
        <CircularProgress />
      ) : (
        Object.keys(customerRallyDataDict).map((key) => (
          <Paper
            sx={{ width: "90%", mx: "auto", p: 2, borderRadius: "16px" }}
            onClick={() => {
              navigate(`/rally/${key}`);
            }}
          >
            {customerRallyDataDict[key].name}
          </Paper>
        ))
      )}

      <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
        開催中のスタンプラリー
      </Typography>
      {isRallyLoading ? (
        <CircularProgress />
      ) : (
        rallyDataList.map((data) => (
          <Paper
            sx={{ width: "90%", mx: "auto", mb: 2, p: 2, borderRadius: "16px" }}
            onClick={() => {
              navigate(`/rally/${data.uuid}`);
            }}
          >
            {data.name}
          </Paper>
        ))
      )}
    </>
  );
};
